import router, { notFoundRoute } from './router'
import store from './store'

// 白名单
const whiteList = ['/login']

/**
 * 路由前置守卫
 */
router.beforeEach(async (to, from, next) => {
  // console.log('to', to.fullPath)
  // 存在 token ，进入主页
  // if (store.state.user.token) {
  // 快捷访问
  if (store.getters.token) {
    // 判断用户资料是否获取
    // 若不存在用户信息,则需要获取用户信息
    if (!store.getters.hasUserInfo) {
      // 触发获取用户信息的 action
      const res = await store.dispatch('user/getUserInfo')

      let { menus } = res.menuPermission

      menus = menus.map((item) => item.name)

      // 处理用户权限 筛选出需要添加的路由
      const accessRoutes = await store.dispatch('permission/filterRoutes', menus)

      accessRoutes.forEach((item) => {
        router.addRoute(item)
      })

      // 最后再加上 404
      router.addRoute(notFoundRoute)

      console.log('to.fullPath', to.fullPath)
      // 添加完动态路由之后，需要在进行一次主动跳转
      return next(to.fullPath)
    }

    if (to.path === '/login') {
      next('/')
    } else {
      next()
    }
  } else {
    // 没有token的情况下，可以进入白名单
    if (whiteList.indexOf(to.path) > -1) {
      next()
    } else {
      next(`/login?redirectUrl=${to.fullPath}`)
    }
  }
})

router.afterEach((to) => {
  document.title = to.meta.title
})
